import { render, staticRenderFns } from "./CultureViImageDesignInfo.vue?vue&type=template&id=e545b89e&scoped=true&"
import script from "./CultureViImageDesignInfo.vue?vue&type=script&lang=js&"
export * from "./CultureViImageDesignInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e545b89e",
  null
  
)

export default component.exports